import React, { useState } from "react";
import { Button, Col, Row, Typography } from "antd";
import UserAgreementsService, {
  AgreementType,
} from "@services/UserAgreements.service";
import { History } from "history";
import Modal from "../Modal/Modal";
import store from "@features/store";
import { setApiMe } from "@features/action.bfapp";
import { TReducers } from "@features/reducers";
import { connect } from "react-redux";

import * as style from "./InvestmentRiskModalStyle.module.scss"

export type Props = {
  isOpen?: boolean;
  agreementType?: AgreementType;
  redirectionPath?: string;
  history: History<any>;
  investorName?: any;
  onClose: () => void;
};

const InvestmentRiskModal = ({
  isOpen = false,
  agreementType,
  redirectionPath,
  history,
  investorName,
  onClose,
}: Props) => {
  const onConfirmButtonClick = async () => {
    if (agreementType) {
      try {
        await UserAgreementsService.updateUserAgreements(agreementType);
        store.dispatch(setApiMe(true));
        if (redirectionPath) {
          history.push(redirectionPath);
        }
      } catch (error) {
        throw new Error("updateAccessingFunds failed");
      }
    }
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      closable={false}
      onConfirm={() => {}}
      width={720}
      footer={null}
    >
      <>
        <Typography.Paragraph>
          {investorName} this is a high risk investment, how would you feel if
          you lost the money you are about to invest?{" "}
          <a
            className={style.link}
            href="https://bnktothefuture.com/uk-risk-disclaimer/"
            target="_blank"
          >
            Take 2 mins to learn more.
          </a>
        </Typography.Paragraph>

        <Row gutter={12}>
          <Col md={12} xs={24}>
            <div className={style.button}>
              <Button onClick={onConfirmButtonClick}>OK, I understand</Button>
            </div>
          </Col>

          <Col md={12} xs={24}>
            <div className={style.button}>
              <Button onClick={onClose}>Cancel and do not proceed</Button>
            </div>
          </Col>
        </Row>
      </>
    </Modal>
  );
};

const mapStateToProps = (store: TReducers) => ({
  investorName: store.userInfo.full_name?.split(" ")[0],
});

export default connect(mapStateToProps)(InvestmentRiskModal);
